import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_line_draft_lock_serial_number_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  sn_id: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
  delivery_location_guid: fromDatatype.GuidDataFieldInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  insert_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_generic_doc_line_draft_lock_serial_number_RowClass
  implements bl_fi_generic_doc_line_draft_lock_serial_number_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  sn_id: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
  delivery_location_guid: fromDatatype.GuidDataFieldInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  insert_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
